import PropTypes from "prop-types";
import Select from "../common/Select";

function ProfessionalDetails(props) {
    const { handleSelectChange, profileDetails, activeTab } = props;
    const workTypeOptions = [
        "Academic",
        "Medical & Health Sciences",
        "Researcher",
        "Professional",
        "Student"
    ];
    return (
        <div className="">
            <div className="col-lg-12 form-fields-grid">
                <div className="rowManage">
                    <div className={`position-relative py-2 ${props.errored ? "errored" : ""}`}>
                        <Select
                            options={workTypeOptions}
                            optionValues={workTypeOptions}
                            selectedValue={profileDetails?.workType}
                            name="workType"
                            placeholder="Select"
                            handleChange={(value) => handleSelectChange(value, "workType")}
                            labelClass=""
                            label="Work Type"
                            required={activeTab === "professional"}
                            mandatory={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

ProfessionalDetails.propTypes = {
    profileDetails: PropTypes.shape({
        workType: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
        workCategories: PropTypes.string
    }),
    handleSelectChange: PropTypes.func,
    handleChange: PropTypes.func,
    masterData: PropTypes.object,
    activeTab: PropTypes.string
};

ProfessionalDetails.defaultProps = {
    handleSelectChange: () => null,
    handleChange: () => null,
    profileDetails: {},
    masterData: {},
    activeTab: ""
};

export default ProfessionalDetails;
